import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", null, "Material v3", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_color_box = _resolveComponent("color-box")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _withDirectives(_createElementVNode("input", {
      type: "text",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.color) = $event))
    }, null, 512), [
      [_vModelText, _ctx.color]
    ]),
    _withDirectives(_createElementVNode("input", {
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.name) = $event))
    }, null, 512), [
      [_vModelText, _ctx.name]
    ]),
    _createElementVNode("pre", null, _toDisplayString(this.scss()), 1),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.colors(), (color) => {
      return (_openBlock(), _createBlock(_component_color_box, {
        key: color,
        color: color.rgb,
        tone: color.tone.toFixed(2)
      }, null, 8, ["color", "tone"]))
    }), 128))
  ], 64))
}